var _                = require("underscore");
var lib_core         = require("lib-core");

var ToolOptionType   = require("./toolOptionType.js");

var TabView = function(tabModel, parentView, rootStateMachine, configuration) {
    var self = this;

    this.tabModel = tabModel;
    this.parentView = parentView;
    this.rootStateMachine = rootStateMachine;
    this.configuration = configuration;

    this.subnav_button_groups = {};

    this.buttonMap = new lib_core.Collections.HashMap(lib_core.hash.arrayHash);
    this.buttonEventTypeMap = new lib_core.Collections.HashMap();

    this.tabModel.active.onChange("tabActiveChanged", function (value, old) {
        if(value)
            self.setActive();
        else
            self.setInactive();
    }, 10);

    this.tabModel.userMessage.onChange({}, function (value, old) {
        if(value) {
            self.getUserMessage().setMessage(value.message, value.type);
        } else {
            self.getUserMessage().clear();
        }
    }, 10);
};

module.exports = TabView;

TabView.prototype.getYield = function () {
    return this.getEl();
};

TabView.prototype.getSubNav = function () {
    if (!this._tab_subnav) {
        this._tab_subnav = this.getTemplate().addSubNav();
    }
    return this._tab_subnav;
};

TabView.prototype.getToolbar = function () {
    if (!this._toolbar) {
        this._toolbar = this.getTemplate().addToolbar();
        if(this.tabModel.expanded_toolbar){
            this._toolbar.makeExpanded();
        }
    }
    return this._toolbar;
};

TabView.prototype.getUserMessage = function () {
    if (!this._user_message) {
        this._user_message = this.getSubNav().addUserMessage();
    }
    return this._user_message;
};

TabView.prototype.getToolOptions = function () {
    if (!this._tool_options) {
        this._tool_options = this.getSubNav().addToolOptions();
    }
    return this._tool_options;
};

TabView.prototype.setActive = function () {
    this.getTemplate().setActive();
};

TabView.prototype.setInactive = function () {
    this.getTemplate().setInactive();
};

TabView.prototype.getSidebar = function () {
    if (!this._sidebar) {
        this._sidebar = this.getTemplate().addSidebar();
    }
    return this._sidebar;
};

TabView.prototype.getSwitcher = function (name, canNotEdit) {
    if (!this._switcher) {
        this._switcher = this.getTemplate().addSwitcher(canNotEdit);
    }
    return this._switcher;
};

TabView.prototype.getTemplate = function () {
    if (!this._template) {
        this._template = this.parentView.getTemplate().addTab();
    }
    return this._template;
};

TabView.prototype.getEl = function () {
    if (!this._el) {
        this._el = this.getTemplate().getYield();
    }
    return this._el;
};

TabView.prototype.getButton = function () {
    if (!this._button) {
        this._button = this.getTemplate().getYield();
    }
    return this._button;
};

TabView.prototype.setTheme = function (theme) {
    this.getTemplate().setTheme(theme);
};

TabView.prototype.registerButton = function(buttonElements) {
    var self = this;

    var name      = buttonElements.name;
    var title     = buttonElements.title;
    var icon      = buttonElements.style && buttonElements.style.icon || "";
    var group     = buttonElements.group;
    var sortOrder = buttonElements.sortOrder;
    var eventType = buttonElements.eventType;
    var scope     = buttonElements.scope || "";
    var mode      = buttonElements.mode || "";
    var offsetButton = buttonElements.offsetButtons;
    var position = buttonElements.position || "middle";
    var cssClass = buttonElements.class || "";

    var jqueryEventType = null;
    var button = this.buttonMap.get([name, title, icon, sortOrder, mode]);

    // CHECK WHICH GROUP THEY BELONG TO AND CALL CORRECT UI TEMPLATE FUNCTION FOR CREATION
    if(!button) {
        if (group && group == "tool") {
            // ADD TO TOOLBAR
            if(offsetButton) {
                button = this.getToolbar().addOffsetTool(name, title, icon);
                jqueryEventType = "Cioui:ToolbarOffsetTool:clicked";
            }
            else {
                button = this.getToolbar().addTool(name, title, icon);
                jqueryEventType = "Cioui:ToolbarTool:clicked";
            }
        } else {
            // ADD TO SUBNAV
            if(group && group == "buttons"){
                if(!_.has(this.subnav_button_groups, group)){
                    this.subnav_button_groups[group] = this.getSubNav().addGroup(position, 100);
                }
                button = this.subnav_button_groups[group].addButton(name, title, icon, cssClass, this.configuration.applyButtonClass);
                jqueryEventType = "Cioui:SubNavButton:clicked";
            } else if(group && group == "toggle buttons"){
                if(!_.has(this.subnav_button_groups, group)){
                    this.subnav_button_groups[group] = this.getSubNav().addGroup('right', 100);
                }
                button = this.subnav_button_groups[group].addToggleButton(name, title, icon, null, this.configuration.applyButtonClass);
                jqueryEventType = "Cioui:SubNavToggleButton:clicked";
            } else {
                if(!_.has(this.subnav_button_groups, group)){
                    var weight;
                    switch(group){
                        case "modifier":
                            weight = 1;
                            break;
                        case "navigation":
                            weight = 2;
                            break;
                        case "history":
                            weight = 3;
                            break;
                        default:
                            weight = 100;
                    }
                    this.subnav_button_groups[group] = this.getSubNav().addGroup('left', weight);
                }
                button = this.subnav_button_groups[group].addTool(name, title, icon, sortOrder);
                jqueryEventType = "Cioui:SubNavTool:clicked";
            }
        }
        this.buttonMap.put([name, title, icon, sortOrder], button);
        this.buttonEventTypeMap.put(button, jqueryEventType);
    }

    if(!jqueryEventType) jqueryEventType = this.buttonEventTypeMap.get(button);

    // ATTACH EVENT LISTENER
    button.$el.on(jqueryEventType, function (e) {
        var cEvent = new lib_core.GuiEvent(eventType).scope(scope);

        for (var eventData in buttonElements.eventData) {
            cEvent.data(eventData, buttonElements.eventData[eventData]);
        }

        self.rootStateMachine.handle(cEvent);
    });

    return button;
};

TabView.prototype.showToolOptions = function (toolOptions) {
    var self = this;

    var template = this.getToolOptions();
    var toolViews = [];

    for (var option in toolOptions) {
        (function () {
            var toolOption = toolOptions[option];
            var scope  = toolOption.scope ? toolOption.scope : "";
            switch (toolOption.type) {
                case ToolOptionType.BUTTON:
                    var button = template.addButton(toolOption.description, toolOption.description, toolOption.style.icon);
                    button.$el.on("Cioui:SubNavTool:clicked", function (e) {
                        var cEvent = new lib_core.GuiEvent(toolOption.eventType).scope(scope);
                        for (var eventData in toolOption.eventData) {
                            cEvent.data(eventData, toolOption.eventData[eventData]);
                        }
                        self.rootStateMachine.handle(cEvent);
                    });
                    toolViews.push(button);
                    break;

                case ToolOptionType.SELECTBOX:
                    var selectbox = template.addSelectBox(toolOption.name, toolOption.description, toolOption.list, toolOption.initValue);
                    selectbox.$el.on("Cioui:SubNavTool:value", function (e, value) {
                        var cEvent = new lib_core.GuiEvent(toolOption.eventType).scope(scope);
                        for (var eventData in toolOption.eventData) {
                            cEvent.data(eventData, toolOption.eventData[eventData]);
                        }
                        cEvent.data('value', value);
                        self.rootStateMachine.handle(cEvent);
                    });
                    toolViews.push(selectbox);
                    break;

                default:
                    break;
            }
        })();
    }
    return toolViews;
};

TabView.prototype.hideToolOptions = function () {
    var template = this.getToolOptions();
    template.clear();
    this._tool_options = null;
};
